import { useState, useEffect, useCallback } from 'react';

export const useSwipeGesture = ({ zone = null, exceptionZoneList = null, toggleHandler, isOpen = false }) => {
  const [swipedZone, setSwipedZone] = useState(zone);
  const [isZoneOpened, setIsZoneOpened] = useState(isOpen);
  const [isTouchEnabled, setIsTouchEnabled] = useState(false);

  const handleGesture = useCallback(
    ({ touchStart, touchStop }) => {
      const changeY = touchStart.y - touchStop.y;
      const changeX = touchStart.x - touchStop.x;

      if (changeY > 0) {
        console.log('changeY >= 0 swiped up');
        // swiped up
        toggleHandler(true);
      }
      if (changeY < 0) {
        console.log('changeY < 0 swiped down');
        // swiped down
        toggleHandler(false);
      }
    },
    [toggleHandler],
  );

  const checkTouchEnabled = () => {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
  };

  useEffect(() => {
    setIsTouchEnabled(checkTouchEnabled());
  }, []);

  useEffect(() => {
    if (!isTouchEnabled || !swipedZone) return;

    let touchStart = { x: 0, y: 0 };
    let touchStop = { x: 0, y: 0 };
    let exceptionZone = null;

    const onTouchStart = e => {
      e.preventDefault();
      if (typeof e['changedTouches'] !== 'undefined') {
        const touch = e.changedTouches[0];
        touchStart.x = touch.screenX;
        touchStart.y = touch.screenY;
      } else {
        touchStart.x = e.screenX;
        touchStart.y = e.screenY;
      }

      if (!exceptionZoneList) return;

      exceptionZone = Object.keys(exceptionZoneList).reduce((z, key) => {
        const excZone = exceptionZoneList[key].reduce((el, zone) => {
          const excEl = document.getElementsByClassName(zone)[0];
          const isZone = e.target.classList?.value.includes(zone) || excEl?.contains(e.target);
          return isZone ? excEl : el;
        }, null);
        return excZone ? [key, excZone] : z;
      }, []);
    };
    const onTouchEnd = e => {
      e.preventDefault();
      if (typeof e['changedTouches'] !== 'undefined') {
        const touch = e.changedTouches[0];
        touchStop.x = touch.screenX;
        touchStop.y = touch.screenY;
      } else {
        touchStop.x = e.screenX;
        touchStop.y = e.screenY;
      }

      if (exceptionZone?.length) {
        const [type, zone] = exceptionZone;
        let event = null;
        if (type === 'click' || (type === 'custom' && touchStart.y - touchStop.y === 0)) {
          // type 'custom' -> conditional triggering click event depending on gesture
          // touchStart.y - touchStop.y === 0 -> tap gesture
          // goal -> trigger click only on tap, but not on swipe up/down
          event = new Event('click', { bubbles: true });
          zone.dispatchEvent(event);
          return;
        }
      }
      handleGesture({ touchStart, touchStop });
    };

    swipedZone.addEventListener('touchstart', onTouchStart, false);
    swipedZone.addEventListener('touchend', onTouchEnd, false);

    return () => {
      swipedZone.removeEventListener('touchstart', onTouchStart, false);
      swipedZone.removeEventListener('touchend', onTouchEnd, false);
    };
  }, [swipedZone, handleGesture, isTouchEnabled, exceptionZoneList]);

  return [setIsZoneOpened, setSwipedZone];
};
